import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useApolloClient } from '@apollo/client';
import Constants from '../../Constants';
import ENDPOINT from '../graphql/GraphQLConstants';
import CloseIcon from '@material-ui/icons/Close';
import PubSub from 'pubsub-js';
import {
    Grid,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    IconButton,
} from '@material-ui/core';
const useStyles = makeStyles({
    eirDialog: {
        padding: '8px 0px 40px',
        '@media (max-width: 767px)': {
            fontSize: '18px',
            padding: '0px 0px 18px',
        },
    },

    dialogPaper: {
        overflowY: 'visible !important',
        maxWidth: '700px',
    },

    dialogTitle: {
        position: 'relative',
    },
    closeButton: {
        position: 'absolute',
        right: '-15px',
        top: '-15px',
        fontSize: '18px',
        color: '#892ba0',
        boxShadow: '0px 0px 10px #0000002B',
        opacity: 1,
        outline: 'none',
        background: '#fff',
        '&:focus,&:hover': {
            background: '#fff',
            outline: 'none',
        },
    },
    notification: {
        color: '#323435',
        fontSize: '20px',
        textAlign: 'center',
        padding: '18px 56px 0px',
        fontFamily: ' eir-medium !important',
        '@media (max-width: 767px)': {
            fontSize: '18px',
            padding: '0px',
        },
    },
    pupleBtn: {
        borderRadius: '2rem',
        fontSize: 18,
        textTransform: 'initial',
        padding: '8px 45px',
        border: '1px solid '+Constants.siteTheme.primaryTheme,
        background: Constants.siteTheme.primaryTheme,
        color: '#fff',
        '@media (min-width:280px) and (max-width: 320px)': {
            fontSize: 12,
            padding: '6px 22px',
        },
        '@media (min-width:321px) and (max-width: 767px)': {
            padding: '8px 30px',
            fontSize: 16,
        },
        '@media (min-width:768px) and (max-width: 1024px)': {
            fontSize: 16,
        },
        '&:focus,&:hover': {
            outline: 'none',
            background: Constants.siteTheme.primaryTheme,
            color: '#fff',
        },
    },
    eirDialogContent: {
        padding: '0px 110px',
        '@media (max-width: 767px)': {
            padding: '8px 24px',
        },
    },
    button: { outline: 'none' },
    cancelBtn: {
        borderRadius: '2rem',
        fontSize: 18,
        textTransform: 'initial',
        padding: '8px 48px',
        border: '1px solid #892ba0',
        background: '#fff',
        color: '#892ba0',
        outline: 'none',
        marginRight: '10px',
        '@media (min-width:280px) and (max-width: 320px)': {
            fontSize: 12,
            padding: '6px 24px',
        },
        '@media (min-width:321px) and (max-width: 767px)': {
            padding: '8px 32px',
            fontSize: 16,
        },
        '@media (min-width:768px) and (max-width: 1024px)': {
            padding: '8px 48px',
            fontSize: 16,
        },
        '&:focus,&:hover': {
            outline: 'none',
        },
    },
});
// function to hide and show based n the confirm satatus and edit status and based on yes and no radio buttons
export const EirConfirmDialog = props => {
    const [open, setOpen] = useState(true);
    const graphql = useApolloClient();
    const classes = useStyles();
    const handleClose = () => {
        setOpen(false);
        props.setConfirmErrorMsg('');
        if ((props.selectedTime != '' || props.MobileValidationStatus) && !props.confirmField) {
            props.handleIntermediateStatus(true);
            props.setconfirmBtnStatus(false);
            setTimeout(function () {
                props.refs.yesToggleBtnRef.current.click();
            }, 100);
        } else if (!props.confirmField) {
            props.setconfirmBtnStatus(false);
            props.handleCofirmationStatus(false);
            props.refs.yesToggleBtnRef.current.click();
        } else {
            //kept blank for senarios to work
        }
        if (props.confirmField) {
            props.refs.yesToggleBtnRef.current.click();
            props.storeValidePhoneNumber(props.validPhoneNumber);
            props.handleCofirmationStatus(true);
            props.setdiscount(false);
            props.setconfirmBtnStatus(true);
        }
    };
    const handleConfirm = async () => {
        props.setConfirmErrorMsg('');
        props.handleCofirmationStatus(false);
        props.setconfirmBtnStatus(true);
        setOpen(false);

        try {
            if (props.isDevice != null) {
                const res = await graphql.mutate({
                    mutation: ENDPOINT.REMOVE_DISCOUNT,
                    variables: {
                        prospectUuid: props.prospectUuid,
                        cartOfferId: props.offerId,
                    },
                });

                if (res.data.removeDiscount) {
                    props.setdiscount(true);
                }
            }
            // remove port
            const res = await graphql.mutate({
                mutation: ENDPOINT.REMOVE_PORT,
                variables: {
                    prospectUuid: props.prospectUuid,
                    cartOfferId: props.offerId,
                },
            });

            if (res.data.removePort) {
                PubSub.publish(Constants.eventKeys.updatedCartDetails, res.data.removePort);
            }
        } catch (err) {
            //handle err here
        }
    };

    return (
        <div>
            <Dialog
                PaperProps={{ className: classes.dialogPaper }}
                open={open}
                onClose={handleClose}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                className={classes.eirDialogContainer}>
                <DialogTitle id='alert-dialog-title' className={classes.dialogTitle}></DialogTitle>
                <IconButton
                    aria-label='close'
                    className={classes.closeButton}
                    onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <DialogContent className={classes.eirDialogContent}>
                    <DialogContentText
                        id='alert-dialog-description'
                        className={classes.notification}>
                        If you choose not to move your number, the price of your handset may change.
                        <br />
                        <br /> Do you wish to continue?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid item xs={12} sm={12} md={12} align='center' className={classes.eirDialog}>
                        <Button className={classes.cancelBtn} onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button className={classes.pupleBtn} onClick={handleConfirm}>
                            Continue
                        </Button>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>
    );
};
